var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ReactCustomElementWithProps } from 'web-components-with-react';
import FindTheRightOil from './components/FindTheRightOil';
var componentName = 'find-oil-component';
var StyledApp = function (props) {
    var baseApi = props.baseApi, locales = props.locales;
    return _jsx(FindTheRightOil, __assign({}, props, { baseAPI: baseApi, locales: locales }), void 0);
};
if (!customElements.get(componentName)) {
    customElements.define(componentName, ReactCustomElementWithProps(StyledApp, ['country', 'i18n', 'base-api', 'locales', 'restore', 'preserved'], false));
}
